import { h } from "@stencil/core";

const AuthHeader = ({ title, subhead }: { title: string, subhead: string }) => {
  return (
    <header class="step-header">  
      <figure style={{ height: "72px" }}>
        <picture>
          <source srcSet="https://assets.adsttc.com/doodles/flat/logo-white-isotype.svg" media="(prefers-color-scheme: dark)" />
          <img src="https://assets.adsttc.com/doodles/flat/logo-blue-isotype.svg"
            style={{ height: "100%", width: "auto", objectFit: "contain" }}
            alt="ArchDaily" />
        </picture>
      </figure>
      <header>
        <h2 class="title">{title}</h2>
        <p class="subhead" innerHTML={subhead}></p>
      </header>
    </header>
  );
};

export default AuthHeader;
